import { Box } from "@mui/system";

interface Props {
  Component: React.JSX.ElementType;
  text: string;
}

const FOOTER_ITEM_CONTAINER_SX = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  mb: 1,
  marginX: 0,
};

const ContentFooterSocialIcon = ({ Component, text }: Props) => {
  return (
    <Box sx={FOOTER_ITEM_CONTAINER_SX}>
      <Box sx={{ maxHeight: 50 }}>
        <Component
          sx={{
            maxHeight: "100%",
            fontSize: "3em",
            color: "white",
            backgroundColor: "black",
            padding: 1.1,
            borderRadius: "50%",
          }}
        />
      </Box>
      &nbsp; {text}
    </Box>
  );
};

export default ContentFooterSocialIcon;
